import React from 'react';
import { Star, Quote, CheckCircle2 } from 'lucide-react';
const testimonials = [{
  quote: "I made the Oaxacan mole last weekend and my husband — who lived in Mexico City for 3 years — said it was the most authentic he's had outside Mexico. The peanut butter swap blew my mind.",
  name: 'Sarah M.',
  city: 'Austin, TX',
  avatar: 'https://i.pravatar.cc/100?img=47'
}, {
  quote: "Finally, a cookbook that doesn't require me to order $50 worth of dried chiles online. I found everything at my local Kroger and the Baja fish tacos were crispier than the ones we had in Cabo.",
  name: 'David L.',
  city: 'Chicago, IL',
  avatar: 'https://i.pravatar.cc/100?img=11'
}, {
  quote: "The slow cooker Pibil hack is a lifesaver for busy weeknights. It tastes like it's been roasting underground for 12 hours, but it took me 15 minutes of prep before work.",
  name: 'Elena R.',
  city: 'Miami, FL',
  avatar: 'https://i.pravatar.cc/100?img=32'
}, {
  quote: "I was skeptical about the mixology guide, but the Mezcalita recipe alone is worth the price. It's exactly what we drank at our honeymoon resort in the Riviera Maya.",
  name: 'Michael T.',
  city: 'Denver, CO',
  avatar: 'https://i.pravatar.cc/100?img=68'
}];
export function Testimonials() {
  return <section className="w-full py-16 md:py-24 bg-[#F5F1E8]" data-id="element-415">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-416">
        <div className="text-center mb-12" data-id="element-417">
          <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-4" data-id="element-418">
            Real Travelers, Real Resort Flavors
          </h2>
          <p className="text-xl text-[#3E2723]/70" data-id="element-419">
            Join thousands of home cooks bringing paradise to their dinner
            tables.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-420">
          {testimonials.map((t, idx) => <div key={idx} className="bg-[#FBF7F0] p-8 rounded-2xl shadow-lg border border-[#3E2723]/5 relative" data-id="element-421">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#C2410C]/10" data-id="element-422" />
              <div className="flex gap-1 mb-4" data-id="element-423">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-424" />)}
              </div>
              <p className="text-lg text-[#3E2723]/80 mb-6 italic relative z-10" data-id="element-425">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-426">
                <img src={t.avatar} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#C2410C]" data-id="element-427" />
                <div data-id="element-428">
                  <div className="font-bold text-[#3E2723]" data-id="element-429">{t.name}</div>
                  <div className="text-sm text-[#3E2723]/60" data-id="element-430">{t.city}</div>
                </div>
                <div className="ml-auto flex items-center gap-1 text-xs font-semibold text-[#14B8A6] bg-[#14B8A6]/10 px-2 py-1 rounded-full" data-id="element-431">
                  <CheckCircle2 className="w-3 h-3" data-id="element-432" />
                  Verified Buyer
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}